import type { CSSProperties, ReactNode } from 'react';

import useColor from '@/hooks/domain/useColor';
import { animation } from '@/styles/style';

import Spinner from '../Common/Spinner';
import TransitionPortal from '../Common/TransitionPortal';

type Props = {
  loading: boolean;
  style?: CSSProperties;
  message?: ReactNode;
  loadingChildren?: ReactNode;
};

const GlobalLoader = (props: Props) => {
  const color = useColor();
  return (
    <TransitionPortal
      status={props.loading}
      layerId="page-loading-layer"
      background={{
        enable: true,
        style: {
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(2px)',
        },
      }}
      style={{
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        border: 'none',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 'none',
        backdropFilter: 'none',
      }}
      animations={{
        in: animation.fadeIn,
        out: animation.fadeOut,
      }}
    >
      {props.loadingChildren ? (
        props.loadingChildren
      ) : (
        <div className="flex flex-col items-center justify-center gap-4">
          <Spinner size={32} color={color.primary100} />
          {props.message}
        </div>
      )}
    </TransitionPortal>
  );
};

export default GlobalLoader;
